import * as React from 'react';

import { X } from 'lucide-react';

import { Box, IconButton, Stack } from '@mui/material';
import { lighten } from '@mui/system';

import { useNotifications } from '@itp/talent/hooks/useNotifications';
import { theme } from '@itp/talent/theme';

import { ErrorAlert, InfoAlert, SuccessAlert, WarningAlert } from '../../core/alert';
import { ButtonTextPrimary } from '../../core/button';

export const Notifications = () => {
  const { notifications, removeNotification } = useNotifications();

  const components = {
    error: ErrorAlert,
    info: InfoAlert,
    success: SuccessAlert,
    warning: WarningAlert,
  };

  const handleClose = (id: string) => {
    removeNotification(id);
  };

  if (!notifications.length) {
    return null;
  }

  return (
    <Box position="sticky" top={{ sm: '67px', xs: '59px' }} zIndex={100}>
      {notifications.map((notification, key) => {
        const Component = components[notification.type || 'success'];
        return (
          <Box
            alignItems="center"
            bgcolor={`${lighten(theme.palette[notification?.type || 'success'].light, 0.9)}`}
            display="flex"
            justifyContent="center"
            key={key}
          >
            <Component
              action={
                <Stack columnGap={1} flexDirection="row" justifyContent="center">
                  {notification.action?.onClick && (
                    <ButtonTextPrimary onClick={notification.action?.onClick}>
                      {notification.action?.label}
                    </ButtonTextPrimary>
                  )}
                  <IconButton
                    aria-label="Close notification"
                    color="primary"
                    onClick={() => handleClose(notification.id)}
                    size="small"
                  >
                    <X size={16} />
                  </IconButton>
                </Stack>
              }
              sx={{ maxWidth: 'lg', px: 3, width: '100%' }}
            >
              {notification.content}
            </Component>
          </Box>
        );
      })}
    </Box>
  );
};
